module.exports = __webpack_public_path__ + "static/img/HA.6a4b628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HA.png
// module id = S3ko
// module chunks = 34